import { SelectItem, SelectOption, isDivider, isOptionGroup } from "./Select";

// Match against the sublabel too (e.g. "TX") so an address subline actually disambiguates same-named options.
const matchesQuery = (option: SelectOption, lowerQuery: string): boolean =>
  option.label.toLowerCase().includes(lowerQuery) || !!option.sublabel?.toLowerCase().includes(lowerQuery);

const filterItems = (items: SelectItem[], query: string): SelectItem[] => {
  if (!query) {
    return items;
  }

  const lowerQuery = query.toLowerCase();
  const filtered: SelectItem[] = [];

  items.forEach((item) => {
    if (isDivider(item)) {
      filtered.push(item);
      return;
    }

    if (isOptionGroup(item)) {
      const matchingOptions = item.options.filter((opt) => matchesQuery(opt, lowerQuery));
      if (matchingOptions.length > 0) {
        filtered.push({
          ...item,
          options: matchingOptions
        });
      }
      return;
    }

    if (matchesQuery(item, lowerQuery)) {
      filtered.push(item);
    }
  });

  return filtered.filter((item, index, arr) => {
    if (!isDivider(item)) {
      return true;
    }

    const isFirst = index === 0;
    const isLast = index === arr.length - 1;
    const prevIsDivider = index > 0 && isDivider(arr[index - 1]);

    return !isFirst && !isLast && !prevIsDivider;
  });
};

export const getFilteredItems = ({
  hasSearchInDropdown,
  isSearchable,
  isMultiSelect,
  items,
  searchQuery
}: {
  hasSearchInDropdown: boolean;
  isSearchable: boolean;
  isMultiSelect: boolean;
  items: SelectItem[];
  searchQuery: string;
}): SelectItem[] => {
  const shouldFilterItems = (hasSearchInDropdown || isSearchable || isMultiSelect) && searchQuery.trim().length > 0;

  if (!shouldFilterItems) {
    return items;
  }

  return filterItems(items, searchQuery);
};
